import InitApi from "api/InitApi";
import {
	BOOK_UPLOAD_STEPS,
	buildFormData,
	splitBookFileFields,
	uploadBookFiles,
} from "api/BookResource/bookFileUpload";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";
import toast from "react-hot-toast";
import ServerErrors from "components/SeverErrors";

const useUpdatePhysicalBook = (book, { onStepChange } = {}) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const update = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");
		const body = deleteEmptyObjects(obj);
		const { files, metadata } = splitBookFileFields(body);
		const hasFiles = Boolean(files.book_cover);

		try {
			onStepChange?.(BOOK_UPLOAD_STEPS.SAVING_DETAILS);

			const response = await instance.post(
				`/books/physical/${book}?_method=PATCH`,
				buildFormData(metadata)
			);

			if (hasFiles) {
				onStepChange?.(BOOK_UPLOAD_STEPS.UPLOADING_FILES);
				await uploadBookFiles(instance, book, files);
			}

			await Promise.all([
				queryClient.invalidateQueries("books"),
				queryClient.invalidateQueries("myUploadedBooks"),
			]);

			return response?.data;
		} finally {
			onStepChange?.(null);
		}
	};

	return useMutation(update, {
		onSuccess: async () => {
			toast.success("Book updated successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useUpdatePhysicalBook;
